import { render, staticRenderFns } from "./AlertSOS.vue?vue&type=template&id=22672959&"
import script from "./AlertSOS.vue?vue&type=script&lang=js&"
export * from "./AlertSOS.vue?vue&type=script&lang=js&"
import style0 from "./AlertSOS.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports